// eslint-disable-next-line @typescript-eslint/no-explicit-any
function removeEmptyProperties(obj: { [key: string]: any }): {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
} {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const result: { [key: string]: any } = {};
  for (const [key, value] of Object.entries(obj)) {
    if (
      value !== "" &&
      value !== null &&
      value !== undefined &&
      (!Array.isArray(value) || value.length > 0)
    ) {
      result[key] = value;
    }
  }
  return result;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function formatProperties(obj: { [key: string]: any }): {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
} {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const result: { [key: string]: any } = {};
  for (const [key, value] of Object.entries(obj)) {
    if (
      value === "" ||
      value === null ||
      value === undefined ||
      (Array.isArray(value) && value.length === 0)
    ) {
      result[key] = null;
    } else {
      result[key] = value;
    }
  }
  return result;
}

export { removeEmptyProperties, formatProperties };

export function checkRequireValue(value: unknown): boolean {
  return (
    value === null ||
    value === undefined ||
    (typeof value === "string" && value.trim() === "")
  );
}
